import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as Sentry from '@sentry/react';
import App from './App';
import './index.css';
import './i18n';
import { purgeLegacyRuntimeCaches } from './utils/legacySwCaches';

// Кешовете с отговори на Firestore, които старият service worker пълнеше (TASK_42).
void purgeLegacyRuntimeCaches();

// Initialize Sentry error tracking
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: `school-declarations-frontend@${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,

    // Performance monitoring (sample 10% of transactions)
    tracesSampleRate: 0.1,

    // Session replay (sample 10% of sessions)
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    // Only enable in production
    enabled: import.meta.env.PROD,

    // Filter sensitive data
    beforeSend(event) {
      // Remove authorization headers
      if (event.request?.headers) {
        delete event.request.headers['authorization'];
        delete event.request.headers['cookie'];
      }
      return event;
    },

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
  if (import.meta.env.DEV) console.log('[Sentry] Initialized');
} else {
  if (import.meta.env.DEV) console.log('[Sentry] DSN not configured - error tracking disabled');
}

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
